import React, { useMemo } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { navigate } from "gatsby"
import PropTypes from "prop-types"

import { useRedirectToPro } from "@hooks/siteURLs"
import StatementModule from "@modules/StatementModule"

const InEfficientManagement = ({
  buttonsArray,
  buttonEvent = {},
  button2Event = {},
}) => {
  const { t } = useTranslation()
  const url = useRedirectToPro()

  const buttonClassName = `
    font-semibold 
    !text-[14px]
    !tracking-[0.14px]
    !p-[12px]
    font-inter

    md:!tracking-[0.14px]
    
    desk:!px-[16px]
    desk:!text-[18px]
    desk:!tracking-[0.4px]
    `

  const arrButtons = useMemo(() => {
    const arrButtons = [
      {
        text: t("About_Button1"),
        url: url,
        useNavigate: false,
        as: "link",
        theme: "white-bg",
        inverted: true,
        className: "!leading-4 md:!leading-4 desk:!leading-6",
        dataEvent: buttonEvent,
      },
      {
        text: t("TalkToPaul_Button"),
        url: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0W_ODCbc02igtZr83d_Jh3XTfMQUaKwrgSIHPSoSKuWsm_B6QF5Y41aBKHjWC2noGxx2qUUs4i",
        as: "link",
        dataEvent: button2Event,
        theme: "white-bg",
        inverted: false,
        className: "!leading-3 md:!leading-3 desk:!leading-5",
      },
    ]
    return arrButtons.map(({ className, ...rest }, index) => {
      const btn = buttonsArray[index] ? buttonsArray[index] : {}
      return {
        className: `${buttonClassName} ${className}`,
        ...rest,
        ...btn,
      }
    })
  }, [buttonsArray.length])

  const params = {
    classes: { background: "bg-lblue !py-10 desk:!py-25 xl:!py-25" },
    text: [
      {
        text: t("CaseStudies_BottomSubheader"),
        class: `
          !text-left
          !font-medium
          !leading-120%
          !text-[#151124]
          font-inter
          text-16
          !mb-[8px]
          
          md:w-[580px]
          md:!mb-[8px]
          md:text-20
          md:!text-center

          desk:!mb-[20px]
          desk:text-[40px]
          desk:leading-normal
          desk:w-[960px]

          xl:!mb-[20px]
          xl:text-[40px]
          xl:leading-normal
          xl:w-[960px]  `,
      },
      {
        text: t("CaseStudies_BottomParagraph1"),
        class: `
        !text-[#5B5866]
        text-[14px]
        !leading-150%
        !mb-[20px]
        !text-left

        md:!text-center
        md:w-[580px]

        desk:text-[20px]
        desk:!leading-150%
        desk:font-normal
        desk:w-[960px]
        desk:!mb-[24px]

        xl:text-[20px]
        xl:!leading-150%
        xl:font-normal
        xl:w-[960px]
        xl:!mb-[24px]
        `,
      },
    ],
    buttons: arrButtons,
    buttonWrapperClassName:
      "-mt-3 flex flex-col items-center md:flex-row md:gap-3",
  }

  return <StatementModule {...params} />
}

InEfficientManagement.propTypes = {
  buttonsArray: PropTypes.array,
}

InEfficientManagement.defaultProps = {
  buttonsArray: [],
}

export default InEfficientManagement
